import {
  CruiseControlType,
  FacialType,
  VehicleBoardingType,
  WalkStyle,
} from "@1games-ru/region-shared/dist/enums/account/settings";
import { useMemo } from "react";

export default function useGameplayValues() {
  const walkStyleValues = useMemo(
    () =>
      Object.values(WalkStyle)
        .filter((value) => typeof value === "number")
        .map((value) => value as WalkStyle),
    [],
  );

  const facialValues = useMemo(
    () =>
      Object.values(FacialType)
        .filter((value) => typeof value === "number")
        .map((value) => value as FacialType),
    [],
  );

  const cruiseControlValues = useMemo(
    () =>
      Object.values(CruiseControlType)
        .filter((value) => typeof value === "number")
        .map((value) => value as CruiseControlType),
    [],
  );

  const vehicleEnterValues = useMemo(
    () =>
      Object.values(VehicleBoardingType)
        .filter((value) => typeof value === "number")
        .map((value) => value as VehicleBoardingType),
    [],
  );

  return {
    walkStyleValues,
    facialValues,
    cruiseControlValues,
    vehicleEnterValues,
  };
}
